import React from 'react';
import profileService from '../../services/profileService'
import { toast } from 'react-toastify';
import sessionService from '../../services/sessionService';

export default class ChangeEmail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            username: '',
            edit: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showEditEmail = this.showEditEmail.bind(this);
        this.hideEditEmail = this.hideEditEmail.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }

    componentDidMount() {
        let user = sessionService.getUser();
        this.setState({
            email: user.email,
            username: user.username
        })
    }
    showEditEmail() {
        this.setState({
            edit: true
        })
    }
    hideEditEmail() {
        this.setState({
            edit: false
        })
    }
    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        profileService.update(this.state.email)
            .then(response => {
                sessionService.updateUserEmail(response);
                toast.success("Email is successfully updated!", this.options);
                this.setState({
                    edit: false
                })
            }).catch(error => {
                toast.error(error.response, this.options)
            });
    }

    render() {
        const { username, email, edit } = this.state;
        return (
            <div>

                <div className="subtitle-border-bottom">
                    <ul>
                        <li><p className="grey">Username:</p> <span>{username}</span></li>
                        {!edit ? <li>
                            <p className="grey">Email:</p>
                            <span>{email} <span className="link-look pull-right" onClick={this.showEditEmail}>Edit</span> </span>
                        </li> :
                            <form onSubmit={this.handleSubmit}>
                                <h6 className="mt-3 mb-3 blue"> Change your email <span className="link-look pull-right" onClick={this.hideEditEmail}>Close</span></h6>
                                <hr />
                                <div className="form-group">
                                    <div className="custom-form-inline">
                                        <input id='email' className="form-control bordered" type="text" name="email" value={email} onChange={this.handleChange} />
                                        <button className="btn btn-lightblue pull-right bt-w-95">Update</button>
                                    </div>
                                </div>
                            </form>}

                    </ul>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/profile/changeEmail.js